export default __webpack_public_path__ + "static/media/reset_to_default_buttton_image.9a144198.svg";